import React, { Component } from "react";
import Modal from 'react-modal';
import {useState, useEffect} from 'react';
import api from '../../../config.js';
import { getListFromFlow, getPermission, showMessageError } from '../../../classes/functions';
import './inventory.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaSearch, FaEye, FaArrowLeft, FaArrowRight, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";

import { Link } from 'react-router-dom';
import SelectStatus from "../../../components/Select/SelectStatus/index.js";
import StatusButton from "../../../components/StatusButton/index.js";

export default function Inventory(){
  const [list, setList] = useState([]);
  const [termSearch, setTermSearch] = useState('');
  const [itensByPage, setItensByPage] = useState(50);
  const [carrying, setCarrying] = useState(true);
  const [listStatus, setListStatus] = useState([]);
  const [pesquisa_status, setPesquisaStatus] = useState('');
  const [showSelectStatus, setShowSelectStatus] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [statusButtonWasClicked, setStatusButtonWasClicked] = useState(false);
  const [qtdePage, setQtdePage] = useState(50);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();

  useEffect(()=> {
    async function loadInventory(){
      let data = {
        data: {
          termSearch: termSearch,
          page: 1,
          qtdePage: qtdePage,
        }
      };
      
      api.post("/api/inventory/getSearch", data)
      .then((response) => {
        setList(response.data.dados);
        setTotal(response.data.qtde);
        
        setLastPage(response.data.qtde, qtdePage);
        setCarrying(false);
      }).catch((error) => {
        setCarrying(false);
        console.log(error);
        showMessageError(error.response.data);
      });
    }
    loadInventory();
    
    api.get("/api/generics/getItens?table=9G")
    .then((response) => {
      setListStatus(response.data);
    }).catch((error) => {
      showMessageError(error.response.data);
    });

    return () => {

    }
  }, []);
  
  let delay;
  function search() {
    clearTimeout(delay);
    
    delay = setTimeout(() => {
      setTermSearch(termSearch);
      setPesquisaStatus(selectedStatus);
  
      setPage(1);
      setQtdePage(itensByPage);
  
      let data = {
        data: {
          termSearch: termSearch,
          page: page,
          qtdePage: itensByPage,
          status: selectedStatus
        }
      };
  
      api.post("/api/inventory/getSearch", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setLastPage(response.data.qtde, itensByPage);

          setStatusButtonWasClicked(false);
          setShowSelectStatus(false);
          
          setCarrying(false);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }, 750);
  }

  function nextPage () {
    if (limitPage != page) {
      setCarrying(true);
      
      let data = {
        data: {
          termSearch: termSearch,
          page: page+1,
          qtdePage: qtdePage,
        }
      };
      
      api.post("/api/inventory/getSearch", data)
      .then((response) => {
        setList(response.data.dados);
        setTotal(response.data.qtde);
        setCarrying(false);
        
        setPage(page+1);
        setQtdePage(qtdePage);
      }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function lastPage () {
    if (limitPage != page) {
      setCarrying(true);

      let data = {
        data: {
          termSearch: termSearch,
          page: limitPage,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/inventory/getSearch", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(limitPage);
          setQtdePage(qtdePage);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function firstPage () {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          termSearch: termSearch,
          page: 1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/inventory/getSearch", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(1);
          setQtdePage(qtdePage);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function previewPage () {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          termSearch: termSearch,
          page: page-1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/inventory/getSearch", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setCarrying(false);

          setPage(page-1);
          setQtdePage(qtdePage);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }

  useEffect(() => {
    search();
  }, [itensByPage, termSearch, selectedStatus, page, qtdePage]);

  useEffect(() => {
    search();
  }, [statusButtonWasClicked])
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Inventário">
          {getPermission('OPERACOES - INVENTARIO - CADASTRO') && <Link to="/inventory/cadastrar">
            <button className="buttonInsert">
              Cadastrar
            </button> 
          </Link>}
          <select className='selectQtdeItens' value={itensByPage} onChange={ (e) => setItensByPage(e.target.value)}>
            <option value="50">Itens por página</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
          <input className="inputSearch" value={termSearch} type="text" onChange={(e) => setTermSearch(e.target.value)} placeholder="Pesquisar"/>
          <FaSearch className="iconSearch" style={{color: '#001675' }} size={16}/>
        </Title>

        <div className="container">
          <table>
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">
                  <StatusButton 
                    showSelectStatus={showSelectStatus} 
                    setShowSelectStatus={setShowSelectStatus} 
                    listStatus={listStatus} 
                    setListStatus={setListStatus} 
                    selectedStatus={selectedStatus} 
                    setSelectedStatus={setSelectedStatus} 
                    etStatusButtonWasClicked={setStatusButtonWasClicked} 
                  />
                </th>
                <th scope="col">Descrição</th>
                <th scope="col">Data Criação</th>
                <th scope="col">Hora Criação</th>
                <th scope="col">Usuário</th>
                <th scope="col">Observação</th>
                <th scope="col" className='collumOption'>Opções</th>
              </tr>
            </thead>
            <tbody>
              {list.map((item, index)=>{
                return(
                  <tr key={index}>
                    <td data-label="">{item.id}</td>
                    <td data-label="">{item.status_label}</td>
                    <td data-label="">{item.description}</td>
                    <td data-label="">{item.date}</td>
                    <td data-label="">{item.time}</td>
                    <td data-label="">{item.user}</td>
                    <td data-label="">{item.observation}</td>
                    <td data-label="Opções">
                      <ReactTooltip />
                      {getPermission('OPERACOES - INVENTARIO - CADASTRO') && <Link className="action" to={`/inventory/cadastrar/u${item.id}`} >
                        <FaPen color="#000" size={17} data-tip="Editar"/>
                      </Link>}
                      <ReactTooltip />
                      <Link className="action" to={`/inventory/cadastrar/v${item.id}`} >
                        <FaEye color="#000" size={19} data-tip="Visualizar"/>
                      </Link>
                      <ReactTooltip />
                    </td> 
                  </tr>
                )
              })}
              {list.length == 0 && <tr>
                <td colSpan={8}><label className='required'>Nenhum registro encontrado!</label></td>
              </tr>}
            </tbody>
          </table>
        </div>
        <br/>
        <div className="divGroupPagination">
          <button data-tip="Primeira página" type="button" onClick={firstPage} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft color="#001675" size={17} /></button>
          <button data-tip="Página anterior" type="button" onClick={previewPage} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
          <div className="divLabelPagination">
            <center><label className="labelPage">Exibindo página {page} de {limitPage}</label></center>
          </div>
          <button data-tip="Próxima página" type="button" onClick={nextPage} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
          <button data-tip="Última página" type="button" onClick={lastPage} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight color="#001675" size={17} /></button>
        </div>
      </div>}
    </div>
  )
}